import {
	FormControl,
	FormItem,
	FormMessage,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@uturn/ui-kit';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import type { fixedPriceOptionsType } from '../multi-update-types';

export const PublishStateSelect = ({
	field,
	options,
	placeholder = 'Select value',
}: {
	field: ControllerRenderProps<FieldValues, string>;
	options: fixedPriceOptionsType;
	placeholder?: string;
}) => {
	const toSelect = (value: unknown): string =>
		typeof value === 'boolean' ? String(value) : '';

	return (
		<FormItem>
			<FormControl>
				<Select
					value={toSelect(field.value)}
					onValueChange={(value) => field.onChange(value === 'true')}
				>
					<SelectTrigger
						className="bg-white"
						id="multi-update-publish-state-select"
					>
						<SelectValue placeholder={placeholder} />
					</SelectTrigger>
					<SelectContent>
						{options.map((option) => (
							<SelectItem key={option.id} value={String(option.value)}>
								{option.label}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
